import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { ReviewDashboardData } from "../../../shared/types";

export function useBrandReview(brandId: string | undefined) {
  return useQuery({
    queryKey: ["brand-review", brandId],
    queryFn: () => api.get<{ data: ReviewDashboardData }>(`/api/brands/${encodeURIComponent(brandId!)}/review`),
    refetchInterval: (query) => query.state.data?.data.awaiting_approval.some((item) => item.blog_revision_run?.status === "running") ? 2000 : false,
    enabled: !!brandId,
  });
}
